import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  url?: string
  autoplay?: number
}

function Vimeo(props: Props) {
  const intl = useIntl()
  const { url, autoplay } = props
  const videoId = useMemo(() => {
    const match = url?.match(
      /(?:\/(?:channels\/[\w]+|(?:(?:album\/\d+|groups\/[\w]+)\/)?videos?))?\/(\d+)/i,
    )

    return match ? match[1] : null
  }, [url])

  if (!videoId) {
    return null
  }

  return (
    <iframe
      id="vimeoplayer"
      title={intl.formatMessage({
        id: 'RWBhmlIaTm',
        defaultMessage: 'Vimeo video player',
        description: 'Title for embedded Vimeo video iframe',
      })}
      width="100%"
      height="100%"
      src={`https://player.vimeo.com/video/${videoId}?autoplay=${(autoplay || 0)}`}
      frameBorder="0"
    />
  )
}

export default Vimeo
